import {createAction, props} from '@ngrx/store';
import {BelegVersandstatusPageDTO, PageableDTO} from '../../openapi/fakturierung-openapi';


export class VersandstatusHistoryActions {

  public static loadVersandstatusHistorie = createAction(
    '[VersandstatusHistory] Load versandstatus historie',
    props<{betriebId: string; belegId: string; pageable: PageableDTO}>(),
  );

  public static loadVersandstatusHistorieSuccess = createAction(
    '[VersandstatusHistory] Load versandstatus historie success',
    props<{belegId: string; page: BelegVersandstatusPageDTO}>(),
  );

  public static loadVersandstatusHistorieFailure = createAction(
    '[VersandstatusHistory] Load versandstatus historie failure',
    props<{belegId: string; error: unknown}>(),
  );

  public static clearVersandstatusHistorie = createAction(
    '[VersandstatusHistory] Clear versandstatus historie',
    props<{belegId: string}>(),
  );
}
